import { Box, useTheme, useMediaQuery } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import PasswordGate from '../PasswordGate';
import { useAuth } from '../../context/AuthContext';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

function Layout({ children }: LayoutProps) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Only show password gate for RSVP route when not authenticated
  const isRSVPRoute = location.pathname === '/rsvp';
  if (!isAuthenticated && isRSVPRoute) {
    return <PasswordGate />;
  }

  return (
    <Box display="flex" flexDirection="column">
      <Header />
      <Box sx={{ flex: 1 }}>
        {children}
      </Box>
      {!isMobile && <Footer />}
    </Box>
  );
}

export default Layout;
